import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
@Injectable()
export class ProductInsertService {

    private api_url_set_session_emplacement_article = './api/server.php?cmd=SESSION_EMPLACEMENT_ARTICLES';

    constructor(private http: Http) {

    }

    SetSessionEmplacementArticle(entrepot: any, location: any, capacity: any): Promise<Object> {
        return this.http.get(this.api_url_set_session_emplacement_article
            + '&entrepot=' + entrepot
            + '&location=' + location
            + '&capacity=' + capacity
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// ./src/app/product-insert.service.ts